// extracted by mini-css-extract-plugin
module.exports = {"root":"FAQs_root__A_Bex"};